import { Skeleton } from "antd";

const ContractLoading = () => {
  return (
    <>
      <div className="flex flex-col gap-4 px-5">
        <Skeleton.Input
          active
          block
          className="!min-w-0 !w-full !h-8"
        />
        <Skeleton.Input
          active
          block
          className="!min-w-0 !w-full !h-8"
        />
        <Skeleton.Input
          active
          block
          className="!min-w-0 !w-full !h-8"
        />
        <Skeleton.Input
          active
          block
          className="!min-w-0 !w-full !h-8"
        />
      </div>
      <div className="p-5 fixed bottom-0 max-w-2xl w-full">
        <Skeleton.Input active block className="!h-10" />
      </div>
    </>
  );
};
export default ContractLoading;
